import applyTo from "ramda/src/applyTo";
import memoizeWith from "ramda/src/memoizeWith";
import identity from "ramda/src/identity";
import gte from "ramda/src/gte";
import map from "ramda/src/map";
import sort from "ramda/src/sort";
import keys from "ramda/src/keys";
import prop from "ramda/src/prop";

import { usageRanges } from "../coatingAreaConfig";

export const getLiterageForSqMeterage = (sqMeterageBound) =>
  prop(sqMeterageBound, usageRanges);

/**
 * Get the sq meterage bounds as a list. Memoized for quick retrieval.
 */
export const applyToUsageRangeKeys = applyTo(
  memoizeWith(identity, (obj) => sort(gte, map(Number, keys(obj))))(usageRanges)
);
